// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import type { gtmUserEventType } from 'types/gtm';
import type { State } from 'types/redux';

import Success from './components/Success';
import WhiteConfirmation from './components/WhiteConfirmation';
import CreateProfile from './CreateProfile/CreateProfile';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getStartTime,
  getConfirmationKey
} from 'store/reducers/appointment/selectors';
import { getAppFlow } from 'store/reducers/userInteractions/selectors';

import { APP_FLOW } from 'constants/appFlow';
import { resetScrollPosition } from 'utils/DOM';

const { FIND_ME, IM_NEW_HERE, QUICK_APPT } = APP_FLOW;

export type Props = {|
  /** The appointment date aka as startTime */
  startTime: string,
  /** True to show the "create profile" view */
  showCreateProfile: boolean,
  /** gtm event binded with dispatch */
  gtmUserEvent: gtmUserEventType,
  /** Confirmation Key from appointment, not visible but used by automation team. */
  confirmationKey: string
|};

class ConfirmationPage extends React.Component<Props> {
  componentDidMount() {
    const { gtmUserEvent } = this.props;
    resetScrollPosition(0);
    gtmUserEvent(
      'Reach Confirmation Page',
      'Displayed',
      'Displayed Confirmation Page',
      `GTM_CURRENT_PAGE`
    );
  }

  render() {
    const { startTime, showCreateProfile, confirmationKey } = this.props;
    return (
      <React.Fragment>
        <main>
          <div className="d-none" id="confirmation_key">
            {confirmationKey}
          </div>
          <Success date={new Date(startTime)} />
          <WhiteConfirmation />
        </main>
        <footer> {showCreateProfile && <CreateProfile />} </footer>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state: State): $Shape<Props> {
  const appFlow = getAppFlow(state);
  const showCreateProfile =
    appFlow === FIND_ME || appFlow === IM_NEW_HERE || appFlow === QUICK_APPT;
  return {
    startTime: getStartTime(state),
    showCreateProfile,
    confirmationKey: getConfirmationKey(state)
  };
}

function mapDispatchToProps() {
  return { gtmUserEvent };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationPage);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/ConfirmationPage.js